<template>
    <form role="form" @submit.prevent="lookupAccount">
        <email-input
            @clear="$emit('clearEmail')"
            @input="e => { $emit('input', e); error = null; }"
            :value="value"
        ></email-input>
        <p v-if="error" class="text-danger">{{ error }}</p>
        <submit-button :loading="loading" text="Proceed"></submit-button>
    </form>
</template>

<script>
import axios from "axios";

import EmailInput from './Inputs/Email.vue';
import SubmitButton from "./SubmitButton.vue";

import createGhost from "./mixins/createGhost";

export default {
    name: 'LookupAccount',

    components: {SubmitButton, EmailInput},

    props: {
        findOrCreateGhost: {
            default: false,
            required: false,
            type: Boolean,
        },
        redirect: {
            default: '',
            required: true,
            type: String,
        },
        urlPrefix: {
            required: true,
            type: String,
        },
        value: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            error: null,
            loading: false,
        }
    },

    methods: {
        async lookupAccount() {
            if (!this.value || !this.value.trim()) {
                this.error = 'Please enter your email address.';
                return;
            }

            this.error = null;

            this.loading = true;

            let found = false;
            let hasError = false;

            await axios
                .get(`${this.urlPrefix}/api/v0/users/exist/${this.value}`, {
                    headers: {'Accept': 'application/vnd.api+json'}
                })
                .then((response) => {
                    if (!(response.data.status === 'success' && response.data.data.exists)) {
                        return;
                    }

                    found = true;
                })
                .catch(() => {
                    hasError = true;
                    this.$emit('error');
                });

            if (hasError) {
                this.loading = false;
                return;
            }

            if (found) {
                this.$emit('found', true);
                this.loading = false;

                return;
            }

            if (this.findOrCreateGhost) {
                await createGhost(this.value, this);
            } else {
                this.$emit('found', false);
            }

            this.loading = false;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/LookupAccount.vue